module.exports = __webpack_public_path__ + "static/media/AutomationLicense.5bee489d.svg";